export function getPluginForTable(table: string) {
  const plugin = table.split('_')[0];

  switch (plugin) {
    case 'snowflake': {
      return 'snowflake-config';
    }
    case 'opsgenie': {
      return 'atlassian-ops-genie';
    }
    case 'tempo': {
      return 'tempo-io';
    }
    case 'tf': {
      return 'terraform';
    }
    case 'tfcloud': {
      return 'terraform-cloud';
    }
  }

  return plugin;
}
